import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';
import { BottomNav } from './BottomNav';
import { Toast } from './ui/Toast';
import { ModalContainer } from './modals/ModalContainer';
import { UploadIndicator } from './UploadIndicator';

export function Layout() {
  return (
    <>
      <a href="#content" className="skip-link">Skip to content</a>
      <Navigation />
      <main id="content" role="main">
        <Outlet />
      </main>
      <BottomNav />
      <Toast />
      <UploadIndicator />
      <ModalContainer />
    </>
  );
}
